import { Payment } from '@/interfaces/payment';
import { PaymentResource, paymentResource } from '@/resources/payment.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł płatności
 *
 * @export
 * @class PaymentModule
 * @extends {EntityModule<Payment, PaymentResource>}
 */
export class PaymentModule extends EntityModule<Payment, PaymentResource> {
  constructor() {
    super(paymentResource);

    this.actions = {
      ...this.actions,

      /**
       * Anuluje wypłatę
       *
       * @param {*} context
       * @param {number} id
       * @returns {Promise<boolean>}
       */
      cancel: (context: any, id: number): Promise<boolean> => this.resource.cancel(id),

      /**
       * Anuluje wypłatę w KSAT
       *
       * @param {*} context
       * @param {number} id
       * @returns {Promise<boolean>}
       */
      cancelInKsat: (context: any, id: number): Promise<boolean> => this.resource.cancelInKsat(id),

      /**
       * Ponownie przypina płatność do paczki dokumentów w KSAT
       *
       * @param {*} context
       * @param {number} id
       * @returns {Promise<boolean>}
       */
      reattachInKsat: (context: any, id: number): Promise<boolean> => this.resource.reattachInKsat(id),

      /**
       * Anuluje i ponownie przesyła płatność do KSAT
       *
       * @param {*} context
       * @param {*} variables
       * @returns {Promise<boolean>}
       */
      resendToKsat: (context: any, variables: any): Promise<boolean> => this.resource.resendToKsat(variables),

      /**
       * Aktualizuje dane kontrahenta w KSAT
       *
       * @param {*} context
       * @param {*} variables
       * @returns {Promise<boolean>}
       */
      updateContractor: (context: any, variables: any): Promise<boolean> => this.resource.updateContractor(variables)
    };
  }
}

export default new PaymentModule();
